import { MODALS_ID } from '../../../constants'

import { requestIdentityVerification } from '../../../utils/identityVerification'

import { Button } from '../../../components/button'
import { Modal } from '../../../components/modal'
import { Text } from '../../../components/text'

export function VerificationNoticeModal() {
  return (
    <Modal id={MODALS_ID.VERIFICATION_NOTICE}>
      <Text size={18} weight={600} block={true} $textAlign="center">
        본인 인증 후 청약이 가능해요.
      </Text>
      <Modal.Footer>
        <Button
          type="primary"
          block={true}
          onClick={async () => {
            await requestIdentityVerification(location.href)
          }}
        >
          본인 인증하기
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
